import { render, staticRenderFns } from "./OrderCustomsInvoiceDialog.vue?vue&type=template&id=3e609759&scoped=true"
import script from "./OrderCustomsInvoiceDialog.vue?vue&type=script&lang=js"
export * from "./OrderCustomsInvoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomsInvoiceDialog.vue?vue&type=style&index=0&id=3e609759&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e609759",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e609759')) {
      api.createRecord('3e609759', component.options)
    } else {
      api.reload('3e609759', component.options)
    }
    module.hot.accept("./OrderCustomsInvoiceDialog.vue?vue&type=template&id=3e609759&scoped=true", function () {
      api.rerender('3e609759', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/DocumentsSettings/OrderCustomsInvoiceDialog.vue"
export default component.exports